import { SimpleDialog } from 'global/simple-dialog.src';

(function ready(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}(() => {
    const btnGeneratePDF = document.querySelector('#btn-generate-pdf');
    const handleDownload = () => {
        window.print();
    };
    btnGeneratePDF.addEventListener('click', handleDownload);

    let showMorePopupPlaceholder;
    const showMorePopup = new SimpleDialog(document.querySelector('#show_more_popup'), {
        onOpen() {
            document.querySelector('body').style.overflow = 'hidden';
        },
        onClose() {
            document.querySelector('body').style.overflow = 'visible';
            setTimeout(() => {
                showMorePopup.elem.querySelector('.simple-dialog-body').innerHTML = showMorePopupPlaceholder;
            }, 1000);
        },
    });
    showMorePopupPlaceholder = showMorePopup.elem.querySelector('.simple-dialog-body').innerHTML;
    [].forEach.call(document.querySelectorAll('[href*="/showmore/"]'), (popupTrigger) => {
        popupTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            showMorePopup.show();
            showMorePopup.elem.classList.add('loading');
            const request = new XMLHttpRequest();
            request.open('GET', popupTrigger.getAttribute('href'), true);
            request.onload = function () {
                if (this.status >= 200 && this.status < 400) {
                    showMorePopup.elem.querySelector('.simple-dialog-body').innerHTML = this.response;
                    showMorePopup.elem.classList.remove('loading');
                }
            };
            request.send();
        });
    });
}));
